import { io, type Socket } from 'socket.io-client';
import { Admin } from './admin.namespace';

export const adminSocket: Socket<Admin.ServerEvents, Admin.ClientEvents> = io(
    `${ENV.serverBaseUrl}${Admin.NAMESPACE}`,
    {
        autoConnect: false,
        withCredentials: true,
        transports: ['websocket', 'polling'],
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
    },
);
